import type { Ref } from 'vue';

interface IDefaultPopupState {
    title?: string;
    subtitle?: string;
    type?: string;
    message?: string;
    btnLabel?: string;
    ymSendForm?: string;
    isNeedUploadImages?: boolean;
    isImagesRequired?: boolean;
    isNeedPhone?: boolean;
    isNeedName?: boolean;
}

interface IUseDefaultPopup {
    isDefaultPopupOpen: Ref<boolean>;
    defaultPopupState: Ref<IDefaultPopupState>;

    openDefaultPopup: (options?: IDefaultPopupState) => void;
    onCloseDefaultPopup: () => void;
}

export const useDefaultPopup = (): IUseDefaultPopup => {
  const isDefaultPopupOpen = useState<boolean>('isFastDefaultModalOpen', () => false);
  const defaultPopupState = useState<IDefaultPopupState>('defaultPopupStatePopup', () => ({}));

  const openDefaultPopup = (options?: IDefaultPopupState) => {
    isDefaultPopupOpen.value = true;

    defaultPopupState.value.isNeedUploadImages = options?.isNeedUploadImages;
    defaultPopupState.value.title = options?.title;
    defaultPopupState.value.subtitle = options?.subtitle;
    defaultPopupState.value.type = options?.type;
    defaultPopupState.value.btnLabel = options?.btnLabel;
    defaultPopupState.value.ymSendForm = options?.ymSendForm;

    if (options && options.message) {
      defaultPopupState.value.message = options.message;
    }
  };

  const onCloseDefaultPopup = () => {
    isDefaultPopupOpen.value = false;
  };

  return {
    isDefaultPopupOpen,
    defaultPopupState,

    openDefaultPopup,
    onCloseDefaultPopup
  };
};
